"use client";

import { Separator } from "@repo/ui/components/ui/separator";
import HelpPage from "@repo/next-shared/components/help-page/help-page";
import HelpPageContactLink from "@repo/next-shared/components/help-page/help-page-contact-link";
import Whatsapp from "@components/whatsapp";
import YoutubeVideo from "@components/youtube-video";
import { useTranslations } from "next-intl";

export default function HelpConsumerPage({
  logged = false,
}: {
  logged?: boolean;
}) {
  const t = useTranslations("Help");
  return (
    <div className="w-full">
      {!logged && (
        <div className="relative flex justify-center items-center mb-[40px]">
          <YoutubeVideo heading={t("youtube-title")} YTid="7YoACc3AWBg" />
        </div>
      )}
      <Whatsapp logged={logged} />
      <HelpPage portal="CONSUMER" />
      <Separator className="my-10 max-md:my-4 dark: bg-secondary-gray3"></Separator>
      <HelpPageContactLink contactFormLink="help/contact" />
    </div>
  );
}
